/*
 * Copyright (c) 2018 Hildebrand Technology
 */
import { NgModule } from '@angular/core';
import { ExtraOptions, Routes, RouterModule } from '@angular/router';

import { AuthGuard } from './auth-guard.service';

import { GenerateResetPasswordTokenComponent } from './public/generate-reset-password-token/generate-reset-password-token.component';
import { LoginComponent } from './public/login/login.component';
import { ResetPasswordComponent } from './public/reset-password/reset-password.component';


export const routes: Routes = [
    { path: 'pages', 
      canActivate: [ AuthGuard ], 
      loadChildren: 'app/pages/pages.module#PagesModule' 
    },
    { path: 'generate-password-token', component: GenerateResetPasswordTokenComponent },
    { path: 'login', component: LoginComponent },    
    { path: 'reset-password', component: ResetPasswordComponent }, 
    { path: '', redirectTo: 'pages', pathMatch: 'full' },
    { path: '**', redirectTo: 'pages' },
];

const config: ExtraOptions = {
  useHash: true,
};

@NgModule({
  imports: [RouterModule.forRoot(routes, config)],
  exports: [RouterModule],
  
})

export class AppRoutingModule {
}
